<script setup lang="ts">
/**
 * SourceAttribution — 출처 표기 SSoT(083 FR-005). "출처: {기관명}({발표일}) · 원문 보기" 한 가지 형식만 쓴다.
 * 입시 소식 상세가 첫 소비처이고, 대학별 데이터 페이지(#359)도 이 컴포넌트를 재사용한다 — 화면마다 문구를 새로 만들지 않는다.
 *
 * 여러 출처는 운영자 입력 순서(배열 순서) 그대로 나열한다. 원문 링크는 외부 사이트라 새 창 + `noopener nofollow`.
 */
import { ExternalLink } from 'lucide-vue-next';

import { formatDateOnly } from '#/lib/datetime';

/** 출처 1건 — 기관명·발표일(`YYYY-MM-DD`)·원문 링크. */
interface SourceItem {
  orgName: string;
  publishedOn: string;
  url: string;
}

defineProps<{
  sources: readonly SourceItem[];
}>();
</script>

<template>
  <ul v-if="sources.length > 0" class="flex flex-col gap-1.5 text-[12.5px] text-muted">
    <li
      v-for="(source, index) in sources"
      :key="`${index}-${source.url}`"
      class="flex flex-wrap items-center gap-x-1.5"
    >
      <span>
        출처: <span class="font-bold text-body">{{ source.orgName }}</span
        >({{ formatDateOnly(source.publishedOn) }})
      </span>
      <span aria-hidden="true">·</span>
      <a
        :href="source.url"
        target="_blank"
        rel="noopener nofollow"
        class="inline-flex items-center gap-0.5 font-bold text-brand-muted underline underline-offset-2 hover:text-accent-deep"
      >
        원문 보기
        <ExternalLink class="h-3 w-3" :stroke-width="2" />
        <span class="sr-only">(새 창)</span>
      </a>
    </li>
  </ul>
</template>
